import { Rule, Rules } from "../../../../features/notifications/notificationSlice";
import { getDefaultRule, ErrorType } from "../utils";
import { LanguageText } from "../../../../dictionary/GroupNotificationText";
import useGetLanguage from "../../../../utils/useGetLanguage";
import NotificationRule from "./NotificationRule";
export interface NotificationRuleProps {
  rules: Rules;
  onRuleSpecChange: (ruleID: string, ruleKey: string, ruleValue: any) => void;
  onAddRule: (rule: Rule) => void;
  onRemoveRule: (ruleID: string) => void;
  rulesError: ErrorType["rules"];
}

const NotificationRules = ({
  rules,
  onRuleSpecChange,
  onAddRule,
  onRemoveRule,
  rulesError,
}: NotificationRuleProps) => {
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupNotificationText",
  });

  return (
    <div className="bg-gray-100 rounded-lg p-6 space-y-6">
      <h1 className="text-lg font-semibold text-left text-gray-800 leading-tight mb-2">
        {Language?.rules}
      </h1>
      {Array.isArray(rules) &&
        rules.map((rule) => {
          const isError = rule?.id !== undefined ? rulesError[rule.id] ?? false : false;
          return (
            <NotificationRule
              key={rule.id}
              rule={rule}
              onRuleSpecChange={onRuleSpecChange}
              onRemoveRule={onRemoveRule}
              error={isError}
            />
          );
        })}
      <button
        onClick={() => onAddRule(getDefaultRule())}
        className="mt-2 bg-blue-500 text-white font-bold rounded-md shadow-lg transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400
    w-full sm:w-auto py-2 px-4 sm:py-2 sm:px-6 text-sm sm:text-base"
      >
        {Language?.add}
      </button>
    </div>
  );
};

export default NotificationRules;
